"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._SortOSMDataByStudios = _SortOSMDataByStudios;
exports._HideAndShowHardcodedStudioLocations = _HideAndShowHardcodedStudioLocations;
exports._ManipulateStudioDataBeforeUse = _ManipulateStudioDataBeforeUse;
var helper_const_1 = require("@src/const/helper.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
/**
 * Takes OSM locations and sorts them by the shortest distance to any studio
 * @param data
 */
function _SortOSMDataByStudios(data, studios) {
    var debugResults = data.map(function (loc) {
        var _a;
        var lat = parseFloat(loc.lat);
        var lon = parseFloat(loc.lon);
        var closestStudio = null;
        var shortestDistance = Infinity;
        for (var _i = 0, studios_1 = studios; _i < studios_1.length; _i++) {
            var studio = studios_1[_i];
            var distance = (0, helper_const_1._EarthDistance)(lat, lon, studio.address.latitude, studio.address.longitude);
            //console.log("Distance from OSM", loc.display_name, "to studio", studio.address, "was", distance, "km")
            if (distance < shortestDistance) {
                shortestDistance = distance;
                closestStudio = studio;
            }
        }
        console.log('OSM Location:', loc.display_name);
        console.log('Closest Studio:', (_a = closestStudio === null || closestStudio === void 0 ? void 0 : closestStudio.studioName) !== null && _a !== void 0 ? _a : 'None');
        console.log('Distance (km):', shortestDistance.toFixed(2));
        return { loc: loc, shortestDistance: shortestDistance };
    });
    debugResults.sort(function (a, b) { return a.shortestDistance - b.shortestDistance; });
    return debugResults.map(function (entry) { return entry.loc; });
}
/**
 * Sometimes we have the studio dom objects hardcodeded on the page but want to mimic a search behaviour.
 */
function _HideAndShowHardcodedStudioLocations(config, studios) {
    var _a;
    if ((_a = (0, cash_dom_1.default)('[data-location]')) === null || _a === void 0 ? void 0 : _a.length) {
        (0, cash_dom_1.default)('[data-location]').each(function (i, el) {
            var studioId = el.getAttribute('data-location');
            var studio = studios.find(function (a) { return String(a.id) === studioId; });
            if (typeof (studio === null || studio === void 0 ? void 0 : studio.distanceToUser) === 'number') {
                el.setAttribute('data-set', String(studio.distanceToUser));
            }
            else {
                el.removeAttribute('data-set');
            }
            el.style.display = studio ? 'flex' : 'none';
        });
        reorderForExistingStudios(config, studios);
    }
}
function reorderForExistingStudios(config, studios) {
    var _a, _b;
    var locationObj = (0, cash_dom_1.default)('#' + ((_b = (_a = config.get) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.locationsWrapperId));
    if (locationObj.length) {
        studios.forEach(function (studio) {
            var studioId = String(studio.id);
            if ((0, cash_dom_1.default)('[data-location="' + studioId + '"]').length) {
                locationObj.append((0, cash_dom_1.default)('[data-location="' + studioId + '"]')[0]);
            }
        });
    }
}
function _ManipulateStudioDataBeforeUse(config, studios) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    //Sometimes we have the studios hardcoded on the page and not generated through this module
    //Therefore we have to adjust our internal arrays and enhance those hardcoded studio Dom elements with additional data
    if ((_a = (0, cash_dom_1.default)('[data-location]')) === null || _a === void 0 ? void 0 : _a.length) {
        var harcodededStudios_1 = [];
        var _loop_1 = function (studio) {
            (0, cash_dom_1.default)('[data-location]').each(function (i, el) {
                if (String(studio.id) === el.getAttribute('data-location')) {
                    harcodededStudios_1.push(studio);
                }
            });
        };
        for (var _i = 0, studios_2 = studios; _i < studios_2.length; _i++) {
            var studio = studios_2[_i];
            _loop_1(studio);
        }
        studios = harcodededStudios_1;
    }
    //If studio list is filtered by default
    if ((_d = (_c = (_b = config.get) === null || _b === void 0 ? void 0 : _b.location) === null || _c === void 0 ? void 0 : _c.filterStudioIds) === null || _d === void 0 ? void 0 : _d.length) {
        studios = studios.filter(function (a) { var _a, _b; return (_b = (_a = config.get.location) === null || _a === void 0 ? void 0 : _a.filterStudioIds) === null || _b === void 0 ? void 0 : _b.some(function (b) { return b.toString() === a.id.toString(); }); });
    }
    //Hide studios by id
    if ((_g = (_f = (_e = config.get) === null || _e === void 0 ? void 0 : _e.location) === null || _f === void 0 ? void 0 : _f.hideStudioIds) === null || _g === void 0 ? void 0 : _g.length) {
        studios = studios.filter(function (a) { var _a, _b; return !((_b = (_a = config.get.location) === null || _a === void 0 ? void 0 : _a.hideStudioIds) === null || _b === void 0 ? void 0 : _b.some(function (b) { var _a; return b.toString() === ((_a = a.id) === null || _a === void 0 ? void 0 : _a.toString()); })); });
    }
    // hide studios by tag
    var tagsToHide = (_j = (_h = config.get) === null || _h === void 0 ? void 0 : _h.location) === null || _j === void 0 ? void 0 : _j.hideStudiosByTags;
    if (Array.isArray(tagsToHide) && tagsToHide.length > 0) {
        studios = studios.filter(function (studio) {
            var _a;
            if (typeof studio.studioTags === 'string')
                return !tagsToHide.includes(studio.studioTags);
            return !((_a = studio.studioTags) === null || _a === void 0 ? void 0 : _a.some(function (b) { return tagsToHide.includes(b.name); }));
        });
    }
    // show only studios with this tag
    var tagsToKeep = (_l = (_k = config.get) === null || _k === void 0 ? void 0 : _k.location) === null || _l === void 0 ? void 0 : _l.showOnlyStudiosWithTags;
    if (Array.isArray(tagsToKeep) && (tagsToKeep === null || tagsToKeep === void 0 ? void 0 : tagsToKeep.length) > 0) {
        studios = studios.filter(function (studio) {
            if (!studio.studioTags)
                return false;
            if (typeof studio.studioTags === 'string')
                return tagsToKeep.includes(studio.studioTags);
            return studio.studioTags.some(function (t) { return tagsToKeep.includes(t.name); });
        });
    }
    return studios;
}
